<div class="eod-input">
    <!-- @if(!isLabelVisible){
        <label for="calendarInput" class="form-label">{{calendarLabel}}
            @if(field?.templateOptions?.required){<span class="required-field">*</span>}</label>
    }
    <div class="--is-icon icon-right">
        <input id="calendarInput" type="text" class="form-control"
            [ngClass]="{'ai-scanned-input': field.templateOptions.isAiScannedValue}" #dateInput [formControl]="formControl" [formlyAttributes]="field" (input)="onValueChange()">
        <span class="input-icon right">
            <img [src]="ICONS.CALENDAR" alt="toggle" />
        </span>
    </div> -->
    <div>
        <ds-textbox #dateInput [formControl]="formControl" [formlyAttributes]="field" [textboxInput]="textboxConfig"
            (valueChange)="onValueChange($event)"></ds-textbox>
    </div>
    <!-- <app-calendar-icon></app-calendar-icon> -->
    @if(formControl.errors && formControl.errors.required && isFormSubmitted){<div class="alert-danger">
        @if(!formControl.value || !formControl.value.trim()){<span>
            <b>{{ "label_Required" | translate: param }}</b>
        </span>}
    </div>}
    @if(field.templateOptions.isAiScannedValue){<div class="ai-scanned-label">
        <img src="../../../../../assets/svg-icons/ai.svg" alt="ai" class="required-icon">
        <span>{{ 'label_ai_scanned_values' | translate }}</span>
    </div>}
    @if(field.templateOptions.note && field.templateOptions.note){
    <small class="helper-text">{{field.templateOptions.note}}</small>
    }
</div>